import { resetAnalyticsUser } from '@psl/functions/analytics';
import { memo, ReactNode, useEffect, useRef, useState } from 'react';
import {
  beginLaunchTrackingSpan,
  LaunchTrackEndSpan,
} from '../functions/appLaunchTracking';
import { auth } from '../functions/firebase/firebaseAccess';

const useWaitForFirebaseInit = () => {
  const [init, setInit] = useState(false);

  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) {
      return;
    }

    beginLaunchTrackingSpan('firebase-initialization');

    return auth.onAuthStateChanged(user => {
      if (!initialized.current) {
        initialized.current = true;
        setInit(true);
      }
      if (user == null) {
        resetAnalyticsUser();
      }
    });
  }, []);

  return init;
};

export const EnsureFirebaseInitialized = memo(
  ({ children }: { children?: ReactNode }) => {
    const ready = useWaitForFirebaseInit();
    if (!ready) {
      return null;
    }
    return (
      <LaunchTrackEndSpan name="firebase-initialization">
        {children}
      </LaunchTrackEndSpan>
    );
  },
);
